import React from "react";
import Seo from "../components/Seo";

const TermsConditions = () => {
  return (
    <main className="page legal-page">
      <Seo
        title="Terms & Conditions"
        description="Read the Terms & Conditions for using OctoGames and its services."
        path="/legal/terms"
        keywords="octogames terms, terms and conditions, website terms"
      />
      <div className="container legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-intro">
            Last updated: February 14, 2026
          </p>
          <p className="legal-copy">
            These Terms & Conditions ("Terms") govern your access to and use of OctoGames
            (the "Website"), available at octogames.io. By accessing or using the Website, you
            agree to these Terms.
          </p>

          <h2 className="legal-section-title">1. Operator Information</h2>
          <p className="legal-copy">
            OctoGames is operated by a private individual located in Ukraine ("Operator", "we",
            "us", or "our"). We provide access to browser-based game content for users worldwide.
          </p>

          <h2 className="legal-section-title">2. Eligibility and Acceptance</h2>
          <p className="legal-copy">
            You confirm that you have legal capacity to accept these Terms in your jurisdiction.
            If you are under the age of majority where you live, you may use the Website only with
            consent and supervision of a parent or legal guardian.
          </p>

          <h2 className="legal-section-title">3. Service Description</h2>
          <p className="legal-copy">
            OctoGames provides access to online HTML5 games, user accounts, favorites, and related
            features. Game content is primarily embedded from third-party providers, including
            OctoGames.io partners, and may change, be removed, or become unavailable at any time.
          </p>

          <h2 className="legal-section-title">4. Third-Party Content and Platforms</h2>
          <p className="legal-copy">
            Many games and related assets are supplied by third parties. Your use of those games
            may also be subject to third-party terms, policies, or technical restrictions.
            We are not responsible for third-party services beyond our reasonable control.
          </p>

          <h2 className="legal-section-title">5. Accounts and User Responsibilities</h2>
          <p className="legal-copy">
            If you create an account, you are responsible for maintaining account credentials and
            for all activity under your account. You agree to provide accurate information and keep
            it current.
          </p>
          <ul className="legal-list">
            <li>Do not impersonate another person or provide misleading account information.</li>
            <li>Do not attempt unauthorized access to any part of the Website or related systems.</li>
            <li>Do not use bots, scripts, or automated methods to abuse Website functionality.</li>
            <li>Notify us promptly if you suspect unauthorized account access.</li>
          </ul>

          <h2 className="legal-section-title">6. Acceptable Use</h2>
          <p className="legal-copy">
            You agree not to use the Website for unlawful or harmful activities. Prohibited conduct
            includes, without limitation:
          </p>
          <ul className="legal-list">
            <li>Violating applicable laws or regulations.</li>
            <li>Interfering with Website security, performance, or availability.</li>
            <li>Uploading or transmitting malware, malicious code, or harmful content.</li>
            <li>Infringing intellectual property or other rights of any person or entity.</li>
            <li>Harassing, threatening, defaming, or abusing other users or third parties.</li>
          </ul>

          <h2 className="legal-section-title">7. Intellectual Property</h2>
          <p className="legal-copy">
            The Website design, branding, text, code, and original materials are owned by the
            Operator or used under license, and are protected by applicable intellectual property
            laws. Embedded games and related assets remain the property of their respective owners
            and licensors.
          </p>
          <p className="legal-copy">
            No right, title, or interest is transferred to you except the limited, revocable,
            non-exclusive right to use the Website for personal, non-commercial entertainment,
            subject to these Terms.
          </p>

          <h2 className="legal-section-title">8. Advertising and Monetization</h2>
          <p className="legal-copy">
            The Website may include advertising, sponsorship, affiliate links, and third-party
            promotional content. We are not responsible for third-party offers, websites, or
            transactions entered into between you and any third party.
          </p>

          <h2 className="legal-section-title">9. Availability and Changes</h2>
          <p className="legal-copy">
            We may modify, suspend, or discontinue all or part of the Website at any time, with or
            without notice. We do not guarantee uninterrupted access, error-free operation, or that
            all features will remain available.
          </p>

          <h2 className="legal-section-title">10. Disclaimer of Warranties</h2>
          <p className="legal-copy">
            To the maximum extent permitted by law, the Website is provided on an "as is" and
            "as available" basis without warranties of any kind, whether express or implied,
            including implied warranties of merchantability, fitness for a particular purpose,
            non-infringement, and availability.
          </p>

          <h2 className="legal-section-title">11. Limitation of Liability</h2>
          <p className="legal-copy">
            To the maximum extent permitted by law, the Operator is not liable for indirect,
            incidental, special, consequential, or punitive damages, or for loss of profits, data,
            goodwill, or business opportunities arising from or related to your use of the Website.
          </p>
          <p className="legal-copy">
            Where liability cannot be excluded, it is limited to the minimum extent required by
            applicable law.
          </p>

          <h2 className="legal-section-title">12. Indemnification</h2>
          <p className="legal-copy">
            You agree to indemnify and hold harmless the Operator from claims, liabilities, losses,
            and expenses (including reasonable legal fees) arising from your misuse of the Website,
            violation of these Terms, or infringement of rights of a third party.
          </p>

          <h2 className="legal-section-title">13. Privacy</h2>
          <p className="legal-copy">
            Our handling of personal data is described in our Privacy Policy. By using the Website,
            you acknowledge that your information may be processed as described there.
          </p>

          <h2 className="legal-section-title">14. Copyright and Complaints</h2>
          <p className="legal-copy">
            If you believe content on the Website infringes your rights, contact us with sufficient
            detail to identify the content and your claim. We may remove or restrict access to
            disputed material where appropriate.
          </p>

          <h2 className="legal-section-title">15. Governing Law and Jurisdiction</h2>
          <p className="legal-copy">
            These Terms are governed by the laws of Ukraine, excluding conflict of law principles.
            Disputes shall be subject to the competent courts of Ukraine, unless mandatory consumer
            protection laws in your country of residence provide otherwise.
          </p>

          <h2 className="legal-section-title">16. Changes to These Terms</h2>
          <p className="legal-copy">
            We may update these Terms from time to time. The updated version will be published on
            this page with a revised "Last updated" date. Continued use of the Website after
            changes become effective means you accept the updated Terms.
          </p>

          <h2 className="legal-section-title">17. Contact</h2>
          <p className="legal-copy">
            For legal notices, rights claims, or general support regarding these Terms, contact:
            {" "}
            <a href="mailto:support@octogames.io">support@octogames.io</a>.
          </p>
        </article>
      </div>
    </main>
  );
};

export default TermsConditions;
